export const imagesPath = './src/assets/images/';
export const LANGS = { en: 'en', ru: 'ru', bg: 'bg' };

export const HEADER_JSON = { 'Content-Type': 'application/json' };

export const SERVER_HOST = 'https://travel-app-31rss.herokuapp.com';
/*
export const SERVER_HOST = 'http://localhost:3005';
*/
export const API_COUNTRIES_URLS = `${SERVER_HOST}/countries`;
export const API_AUTH_URLS = `${SERVER_HOST}/auth`;
export const API_COUNTRY_URLS = `${SERVER_HOST}/country`;

export const FOOTER_COPYRIGHT = {
  developers: [
    { link: 'https://github.com/bramov', name: '@Bramov' },
    { link: 'https://github.com/GregoryMoskalev', name: '@GregoryMoskalev' },
    { link: 'https://github.com/HalinaPP', name: '@Halinapp' },
    { link: 'https://github.com/Iogsotot', name: '@IogSotot' },
    { link: 'https://github.com/Levendor', name: '@Levendor' },
  ],
  rsLogo: { link: 'https://rs.school/js/', imgPath: `${imagesPath}/rs_school_js.svg`, name: 'RS SCHOOL' },
};
